import React from "react";
import { Container, Row, Col, Card, Button, Badge } from "react-bootstrap";
import { FaStamp, FaTruck, FaCheckCircle, FaRegClock, FaWhatsapp, FaFacebook } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import logo from "../assets/logo.png"; // replace with a real about image if you have one
import "../Style/AboutUs.css";

const AboutUs = () => {
  const { t } = useTranslation();

  return (
    <section id="about" className="py-5 bg-light about-us">
      <Container>
        <Row className="align-items-center ">
          {/* Image / Visual */}
          <Col md={6} className="mb-4 mb-md-0 column">
            <Card className="border-0 ">
              <Card.Img
                variant="top"
                src={logo}
                alt={t("Falcon Star Stamps")}
                style={{ objectFit: "contain", maxHeight: 320 }}
              />
              <Card.Body className="text-center">
                <div className="d-flex flex-wrap gap-2 justify-content-center">
                  <Badge bg="dark">{t("Rubber Stamps")}</Badge>
                  <Badge bg="secondary">{t("Self-Inking")}</Badge>
                  <Badge bg="primary">{t("Company Seals")}</Badge>
                  <Badge bg="info" text="dark">{t("Embossing Seals")}</Badge>
                  <Badge bg="success">{t("Date Stamps")}</Badge>
                </div>
              </Card.Body>
            </Card>
          </Col>

          {/* Text / Content */}
          <Col md={6}>
            <h2 className="fw-bold mb-3">{t("About Falcon Star Stamps")}</h2>
            <p className=" paragraph">
              {t(
                "We design and produce high-quality custom stamps, seals, and embossers for offices, businesses, and personal use. From classic rubber stamps to modern self-inking and date stamps, our focus is on clean impressions, durable hardware, and quick turnaround."
              )}
            </p>

            {/* Highlights */}
            <Row xs={2} className="g-3 my-3">
              <Col>
                <div className="d-flex align-items-center gap-2">
                  <FaCheckCircle className="text-success" />
                  <span className=" paragraph">{t("Precise, crisp impressions")}</span>
                </div>
              </Col>
              <Col>
                <div className="d-flex align-items-center gap-2">
                  <FaRegClock className="text-primary" />
                  <span className=" paragraph">{t("Fast turnaround")}</span>
                </div>
              </Col>
              <Col>
                <div className="d-flex align-items-center gap-2">
                  <FaStamp className="text-dark" />
                  <span className=" paragraph">{t("Custom text & logos")}</span>
                </div>
              </Col>
              <Col>
                <div className="d-flex align-items-center gap-2">
                  <FaTruck className="text-info" />
                  <span className=" paragraph">{t("Delivery available")}</span>
                </div>
              </Col>
            </Row>

            {/* How it works */}
            <Card className="border-0  mb-3">
              <Card.Body>
                <h5 className="mb-3 mr-0">{t("How It Works")}</h5>
                <ol className="mb-0 ps-3">
                  <li className=" paragraph">{t("Choose your stamp type and size.")}</li>
                  <li className=" paragraph">{t("Send your text/logo or describe your layout.")}</li>
                  <li className=" paragraph">{t("Review and approve the digital proof.")}</li>
                  <li className=" paragraph">{t("We produce and deliver your stamp.")}</li>
                </ol>
              </Card.Body>
            </Card>

            {/* CTAs */}
            <div className="d-flex flex-wrap gap-2">
              <Button
                variant="success"
                onClick={() =>
                  window.open(
                    "https://wa.me/+971559139165?text=Hi! I’d like to order a custom stamp.",
                    "_blank"
                  )
                }
              >
                <FaWhatsapp className="me-2" /> {t("Chat on WhatsApp")}
              </Button>
              <Button
                href="#our-products"
                variant="primary"
                onClick={() =>
                  document.getElementById("products")?.scrollIntoView({ behavior: "smooth" })
                }
              >
                <FaStamp className="me-2" /> {t("View Products")}
              </Button>
              <Button
                variant="outline-primary"
                onClick={() => window.open("https://facebook.com", "_blank")}
              >
                <FaFacebook className="me-2" /> {t("Facebook")}
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AboutUs;
